"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const TableColumnHeader = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
TableColumnHeader.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
TableColumnHeader.defaultProps = {
  className: undefined,
  children: undefined
};
TableColumnHeader.displayName = 'TableColumnHeader';
var _default = exports.default = TableColumnHeader;